var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTagAnnotation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.41812 6.34764C4.58827 5.59468 4.97415 5.05492 5.47014 4.65496C6.47893 3.84181 7.57013 3.68654 8.70606 4.02519C9.43353 4.24233 10.0811 4.67296 10.5535 5.46389C11.0409 6.27986 11.1415 7.17683 10.7948 8.12612C10.5569 8.77838 10.1561 9.22673 9.68461 9.57269C9.57536 9.65257 9.46185 9.72289 9.32045 9.81739C9.53 10.2205 9.73274 10.6097 9.93377 10.9962C9.9376 10.9954 9.92781 11.001 9.91844 10.9999C9.29808 10.907 8.70989 10.682 8.16812 10.2615C8.12383 10.2269 8.0642 10.2086 8.01266 10.2117C7.57588 10.2396 7.14229 10.2188 6.71403 10.0928C6.02852 9.89109 5.4071 9.52262 4.91729 8.83829C4.4113 8.13146 4.20154 7.30565 4.41812 6.34764Z",
    fill: "#9C4C10"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.77585 4.23764C9.54897 3.2588 9.03446 2.55711 8.37315 2.03715C7.0281 0.980055 5.57316 0.778216 4.05859 1.21846C3.08863 1.50074 2.22515 2.06056 1.59536 3.08877C0.945405 4.14952 0.811383 5.31559 1.27365 6.54966C1.59081 7.3976 2.1252 7.98045 2.75386 8.4302C2.89952 8.53405 3.05087 8.62546 3.23941 8.74832C2.96 9.2723 2.68969 9.77836 2.42164 10.2808C2.41653 10.2797 2.42959 10.287 2.44209 10.2855C3.26922 10.1649 4.05348 9.87233 4.77584 9.32569C4.8349 9.28071 4.9144 9.25694 4.98312 9.26096C5.56549 9.29716 6.14361 9.27011 6.71462 9.10629C7.62865 8.84412 8.4572 8.36512 9.11028 7.47549C9.78493 6.55661 10.0646 5.48305 9.77585 4.23764Z",
    fill: "#9C4C10",
    stroke: "#FFEBC7",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagAnnotation);
export default __webpack_public_path__ + "static/media/tag_annotation.d02a691a0eb91378be3be09fc0bd015f.svg";
export { ForwardRef as ReactComponent };